import { defineClientModule } from '@/app/module';
import { copy } from './copy';

/**
 * platform. Install gate polish, Welcome, update prompt, outbox, wake lock, haptics, sound, icons. Its screens live in client/src/app and client/src/lib.
 * See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy imports only.
 */
export default defineClientModule({
  name: 'platform',
  meSections: [{ id: 'devices', order: 90, title: copy.devices.title, component: () => import('./parts/Devices') }],
});
